var _style, _polyline, _line, _line2, _line3, _line4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallLampOutput({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "16.3px",
    height: "14px",
    viewBox: "0 0 16.3 14",
    style: {
      enableBackground: "new 0 0 16.3 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Wall Lamp Output") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "4.7,6.5 0.3,6.5 0.3,9.1 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.5,
    y1: 11.8,
    x2: 9.5,
    y2: 14
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.1,
    y1: 6.5,
    x2: 16.3,
    y2: 6.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.4,
    y1: 0,
    x2: 9.4,
    y2: 2.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.3,
    y1: 6.5,
    x2: 0.3,
    y2: 3.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 9.4,
    cy: 7,
    r: 4.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallLampOutput);
export default __webpack_public_path__ + "static/media/WallLampOutput.3568771e140fc272e64e12e1fa76641b.svg";
export { ForwardRef as ReactComponent };